export default function onPageNavigation() {
    return {
        activeHash: '',
        init() {
            const container = document.querySelector('[data-section-container]');
            container.addEventListener('scroll', () => this.updateActiveSection());
            this.updateActiveSection();
        },
        updateActiveSection() {
            const container = document.querySelector('[data-section-container]');
            let closestSection = '';
            let minOffset = Number.MAX_VALUE;

            container.querySelectorAll('[data-section]').forEach(section => {
                const sectionTop = section.offsetTop - container.scrollTop;
                const offset = Math.abs(sectionTop);
                if (offset < minOffset) {
                    minOffset = offset;
                    closestSection = '#' + section.id;
                }
            });

            this.activeHash = closestSection;
        },
        isActive(hash) {
            return this.activeHash === hash;
        }
    };
}
